import * as R from 'ramda'

const prepareToirIssueForWidget = (toirIssues = [], toirStatuses = []) => R.map((issue) => ({
  ...issue,
  status  : R.find(({ id }) => id === R.prop(`statusId`, issue), toirStatuses),
  endDate : R.prop(`assignedDateTo`, issue),
  typeName: R.path([`type`, `name`], issue),
}), toirIssues)

export default prepareToirIssueForWidget
